import React from "react";
import { CrudPage } from "../components/CrudPage";
import { RoleForm } from "../components/forms/RoleForm";
import { roles } from "../services/api";

const columns = [
  { header: "عنوان", accessor: "label" },
  { header: "مقدار", accessor: "value" },
  {
    header: "تعداد مجوزها",
    accessor: "permissions",
    render: (row: any) => row.permissions?.length || 0,
  },
  {
    header: "سوپر ادمین",
    accessor: "isSuperAdmin",
    render: (row: any) => (row.isSuperAdmin ? "✓" : "-"),
  },
];

export const RolesPage = () => {
  return (
    <CrudPage
      title="نقش‌ها"
      columns={columns}
      queryKey="roles"
      resourceName="roles"
      api={roles}
      FormComponent={RoleForm}
    />
  );
};
